(function ($, Drupal) {

  Drupal.behaviors.buttonTextSwap = {
    attach: (context, settings) => {

      $('.button--text-swap').hover(
        function() {
          $(this).text($(this).attr('data-secondary-title'));
        },
        function() {
          $(this).text($(this).attr('data-primary-title'));
        }
      );

    }
  };

  Drupal.behaviors.buttonAnnounceLeave = {
    attach: (context, settings) => {

      $('.button--announce-leave', context).on('click', function (event) {
        event.stopPropagation();
        return confirm('You are now leaving FundX Funds');
      });

    }
  };

  Drupal.behaviors.buttonPrint = {
    attach: (context, settings) => {

      $('.button--vertical-print', context).on('click', function (event) {
        event.stopPropagation();
        window.print();
      });

    }
  };

})(jQuery, Drupal);
